import './Minesweeper.css';

const Cell = () => (
    <div className="cell outsetBorder" />
);

export default Cell;